var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "12" } },
            [
              _vm.resource.synthesis_comment ||
              Object.values(_vm.resource.synthesis_comment).length === 0
                ? _vm._l(
                    _vm.resource.campaign_field.fields,
                    function (fieldName, index) {
                      return _c(
                        "vs-row",
                        { key: "comment-" + index, staticClass: "mb-20 mt-10" },
                        [
                          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                            _c("span", { staticClass: "font-bold text-lg" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(fieldName.label) +
                                  " :\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "vs-col",
                            { staticClass: "sm:w-4/5 w-full" },
                            [
                              _c("quill-editor", {
                                attrs: {
                                  value:
                                    _vm.resource.synthesis_comment[
                                      fieldName.label
                                    ],
                                  name: "synthesis_comment_" + index,
                                  options: _vm.options,
                                  disabled: false,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.debouncedInputHandleComment(
                                      $event,
                                      fieldName.label
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  )
                : _vm._l(
                    Object.keys(_vm.resource.synthesis_comment),
                    function (fieldName, index) {
                      return _c(
                        "vs-row",
                        { key: "comment-" + index, staticClass: "mb-20 mt-10" },
                        [
                          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                            _c("span", { staticClass: "font-bold text-lg" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(fieldName) +
                                  " :\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "vs-col",
                            { staticClass: "sm:w-4/5 w-full" },
                            [
                              _c("quill-editor", {
                                attrs: {
                                  value:
                                    _vm.resource.synthesis_comment[fieldName],
                                  name: "synthesis_comment_" + index,
                                  options: _vm.options,
                                  disabled: false,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.debouncedInputHandleComment(
                                      $event,
                                      fieldName
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }
                  ),
              _vm._v(" "),
              _c("Actions"),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }